import { Injectable } from '@angular/core'
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
} from '@angular/router'
import { NuclearObservable } from '../nuclear-observable'
import { User } from '../types'
import { userGetters } from '../stores/user-store'
import { UserActions } from '../actions/user-actions'
import { present } from '../utils'

@Injectable()
export class LoginGuard implements CanActivate, CanActivateChild {
  user: User;

  constructor(private router: Router, private userActions: UserActions) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    let url: string = state.url
    return this.checkLogin()
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.canActivate(route, state)
  }

  checkLogin(url?: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.user = NuclearObservable.currentValue<User>(userGetters.user, { toJS: true })
      if (present(this.user))
        resolve(true)

      this.userActions.loadUser().then(() => {
        this.user = NuclearObservable.currentValue<User>(userGetters.user, { toJS: true })
        if (present(this.user)) {
          resolve(true)
        } else {
          if (window) window.location.pathname = '/'
          resolve(false)
        }
      })
    })
  }
}
